



















import { Component, Vue, Prop } from 'vue-property-decorator';
import ITeamMember from '@/store/modules/contact/types/ITeamMember';
import TeamMember from './TeamMember.vue';

@Component({
  components: {
    TeamMember,
  },
})
export default class TeamMembers extends Vue {
  @Prop({ type: String, required: false, default: '' }) public title!: string;
  @Prop({ type: String, required: false, default: '' }) public description!: string;
  @Prop({ type: Array, required: true }) public members!: ITeamMember[];
}
